function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React, { useCallback, useMemo, useRef } from 'react';
import { WmOption, WmSelect } from '@watermarkinsights/ripple-react';
import { injectIntl } from 'react-intl';
import { formatI18n } from '../../I18n/I18n/I18n';
import getOr from '../../utils/getOr';
var getLabelFromEvent = getOr(null)('target.innerHTML');
var getValueFromEvent = getOr(null)('target.value');
function SelectDropDown(_ref) {
  var errorMsg = _ref.errorMsg,
    intl = _ref.intl,
    label = _ref.label,
    _ref$multiple = _ref.multiple,
    multiple = _ref$multiple === void 0 ? false : _ref$multiple,
    onBlur = _ref.onBlur,
    onChange = _ref.onChange,
    onOptionDeselected = _ref.onOptionDeselected,
    options = _ref.options,
    placeholder = _ref.placeholder,
    _ref$required = _ref.required,
    required = _ref$required === void 0 ? false : _ref$required,
    value = _ref.value,
    props = _objectWithoutProperties(_ref, ["errorMsg", "intl", "label", "multiple", "onBlur", "onChange", "onOptionDeselected", "options", "placeholder", "required", "value"]);
  var handleOptionDeselected = useCallback(function (event) {
    if (typeof onOptionDeselected === 'function') {
      onOptionDeselected({
        label: getLabelFromEvent(event),
        value: getValueFromEvent(event)
      });
    }
  }, [onOptionDeselected]);
  var handleOptionSelected = useCallback(function (event) {
    if (typeof onChange === 'function') {
      onChange({
        label: getLabelFromEvent(event),
        value: getValueFromEvent(event)
      });
    }
  }, [onChange]);
  var isValueSelected = useCallback(function (option, index) {
    var isSelected = false;
    if (value) {
      if (typeof value === 'string') {
        var selectedValue = options.find(function (optionObj) {
          return optionObj.value === value;
        }) || {};
        if (selectedValue.value === null || selectedValue.value === undefined || selectedValue.value === '') {
          isSelected = option.value === selectedValue.label;
        } else {
          isSelected = option.value === selectedValue.value;
        }
      } else if (Array.isArray(value)) {
        isSelected = value.indexOf(option.value) !== -1;
      } else if (typeof value === 'object') {
        if (value.value === null || value.value === undefined || value.value === '') {
          isSelected = option.value === value.label;
        } else {
          isSelected = option.value === value.value;
        }
      }
    } else {
      if (index === 0 && !placeholder) {
        isSelected = true;
      }
    }
    return isSelected;
  }, [options, placeholder, value]);
  var dropDownOptions = useMemo(function () {
    var optionsArray = options.map(function (option, index) {
      return /*#__PURE__*/React.createElement(WmOption, {
        key: option.value,
        "aria-selected": isValueSelected(option, index),
        disabled: option.disabled,
        onWmOptionDeselected: handleOptionDeselected,
        onWmOptionSelected: handleOptionSelected,
        role: "option",
        selected: isValueSelected(option, index),
        subInfo: option.description,
        tabindex: "-1",
        value: option.value
      }, option.label);
    });

    //Single placeholder
    if (!multiple && !!placeholder && !value) {
      optionsArray.unshift(/*#__PURE__*/React.createElement(WmOption, {
        key: placeholder,
        "aria-selected": true,
        onWmOptionSelected: handleOptionSelected,
        role: "option",
        selected: true,
        tabindex: "-1",
        value: placeholder
      }, placeholder));
    }
    return optionsArray;
  }, [handleOptionDeselected, handleOptionSelected, isValueSelected, multiple, options, placeholder, value]);
  var contentRef = useRef(null);
  return /*#__PURE__*/React.createElement("span", {
    ref: contentRef
  }, options && options.length > 0 ? /*#__PURE__*/React.createElement(WmSelect, Object.assign({
    errorMessage: errorMsg,
    label: formatI18n(intl, label),
    onWmSelectBlurred: onBlur,
    multiple: multiple,
    requiredField: required
  }, props), dropDownOptions) : null);
}
export default injectIntl(SelectDropDown);